export const formatPercentage = (value?: number | null, nullReplacer = '0.00%', decimalPlace = 2): string => {
  let result = nullReplacer;
  if (value && Number.isInteger(decimalPlace) && decimalPlace > 0) {
    value = +(value * 100).toFixed(decimalPlace);
    // fix -0.00 to become 0.00 by adding 0
    result = (value + 0).toFixed(decimalPlace) + '%';
  }
  return result;
};
